import React from "react";
const Submenu =()=>{

    return(
<React.Fragment>
<li key={`6`}>
  <a
    title={`Catering`}
    href={`assets/web/catering_countyfairfoodswatertown.pdf`}
    rel="noopener noreferrer"
    className="nav-link text-left"
    target="_blank"
  
  >
    {`Catering`}
  </a>

</li>

<li key={`7`}>
  <a
    title={`Bakery`}
    href={`assets/web/bakery_countyfairfoodswatertown.pdf`}
    rel="noopener noreferrer"
    target="_blank"
    className="nav-link text-left"
  >
    {`Bakery`}
  </a>

</li>
</React.Fragment>
    )
}
export default Submenu;